const termsContent = [
    {
      id: 1,
      title: 'Annahme der Bedingungen',
      content: `Durch den Zugriff auf unsere Website und deren Nutzung erklären Sie sich mit diesen Allgemeinen Geschäftsbedingungen einverstanden. Wenn Sie mit einem Teil dieser Bedingungen nicht einverstanden sind, bitten wir Sie, unsere Website nicht zu nutzen.`
    },
    {
      id: 2,
      title: 'Nutzung der Website',
      content: `Unsere Website dient Informationszwecken, einschließlich dem Durchstöbern unserer Speisekarte, dem Kennenlernen unseres Restaurants und dem Abonnieren unseres Newsletters.
  
  - Sie müssen mindestens 16 Jahre alt sein, um unseren Newsletter zu abonnieren.
  - Sie verpflichten sich, unsere Website nicht für rechtswidrige oder störende Aktivitäten zu nutzen, einschließlich, aber nicht beschränkt auf Hacking-Versuche, Spam oder die Verbreitung schädlicher Inhalte.
  - Die unautorisierte Nutzung von Inhalten, Bildern oder Markenauftritt unserer Website ist strengstens untersagt.`
    },
    {
      id: 3,
      title: 'Newsletter-Abonnement',
      content: `Durch das Abonnieren unseres Newsletters stimmen Sie dem Erhalt von Werbe-E-Mails, Sonderangeboten und Neuigkeiten von Casaantonio e piccolo gió zu.
  
  - Sie können sich jederzeit abmelden, indem Sie auf den Link "Abmelden" in unseren E-Mails klicken.
  - Wir geben Ihre E-Mail-Adresse nicht an Dritte zu Werbe- oder Marketingzwecken weiter.
  - Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten finden Sie in unserer Datenschutzerklärung.`
    },
    {
      id: 4,
      title: 'Urheberrecht & geistiges Eigentum',
      content: `Alle Inhalte auf unserer Website, einschließlich Texte, Bilder, Logos und Markenelemente, sind Eigentum von Casaantonio e piccolo gió. Ohne vorherige schriftliche Genehmigung dürfen Sie keine Inhalte verwenden, kopieren, verändern oder verbreiten.`
    },
    {
      id: 5,
      title: 'Dienste Dritter',
      content: `Wir können Dienste Dritter wie Google Maps einbinden, um Nutzern die Lokalisierung unseres Restaurants zu erleichtern. Diese Dienste unterliegen ihren eigenen Nutzungsbedingungen, für deren Inhalte oder Richtlinien wir keine Verantwortung übernehmen.`
    },
    {
      id: 6,
      title: 'Haftungsbeschränkung',
      content: `Casaantonio e piccolo gió haftet nicht für direkte oder indirekte Schäden, die aus der Nutzung unserer Website entstehen. Obwohl wir bemüht sind, genaue Informationen bereitzustellen, übernehmen wir keine Garantie dafür, dass alle Inhalte stets aktuell oder fehlerfrei sind.`
    },
    {
      id: 7,
      title: 'Datenschutz & Datenschutzrichtlinien',
      content: `Die Nutzung unserer Website unterliegt auch unserer Datenschutzerklärung, in der erläutert wird, wie wir Ihre personenbezogenen Daten erheben, verwenden und schützen. Als Website mit Sitz in der EU erfüllen wir die Anforderungen der DSGVO.`
    },
    {
      id: 8,
      title: 'Änderungen der Bedingungen',
      content: `Wir behalten uns vor, diese Allgemeinen Geschäftsbedingungen gelegentlich zu aktualisieren, um Änderungen unserer Dienstleistungen oder rechtlichen Anforderungen zu berücksichtigen. Wesentliche Änderungen werden über unsere Website bekannt gegeben.`
    },
    {
      id: 9,
      title: 'Partnerschaften & Franchising',
      content: `Wir freuen uns über Kooperationsmöglichkeiten mit Unternehmen, Lieferanten und Einzelpersonen, die an einer Zusammenarbeit mit Casaantonio e piccolo gió interessiert sind.
  
  - Wenn Sie Interesse an einer Franchise-Partnerschaft oder Zusammenarbeit haben, kontaktieren Sie uns bitte unter **casa.itzling@gmail.com**.
  - Alle Franchise-Vereinbarungen unterliegen bestimmten Eignungskriterien und müssen von der Geschäftsleitung von Casaantonio e piccolo gió genehmigt werden.
  - Die unautorisierte Nutzung unseres Markennamens oder geistigen Eigentums zu kommerziellen Zwecken ohne unsere schriftliche Zustimmung ist strengstens untersagt.
  
  Für weitere Informationen zu Partnerschaften oder Franchising freuen wir uns auf Ihre Kontaktaufnahme! 🍕🚀`
    }
  ];
  
  export default termsContent;
  
